import type { SourceId, VectorFeature } from '../data/model';
import type { LayerId } from '../project/model';

/** Renderer-independent feature identity retained only for the current session. */
export interface SelectedFeatureRef {
  readonly layerId: LayerId;
  readonly sourceId: SourceId;
  readonly sourceFeatureIndex: number;
  readonly featureId: string | number | null;
  readonly key: string;
}

export type SelectionMethod = 'click' | 'rectangle' | 'lasso';

export type MapSelectionMutation = 'add' | 'replace' | 'toggle' | 'remove';
export type SelectionMutation = MapSelectionMutation;

function featureId(feature: VectorFeature): string | number | null {
  return typeof feature.id === 'string' || typeof feature.id === 'number' ? feature.id : null;
}

export function selectedFeatureRef(
  layerId: LayerId,
  sourceId: SourceId,
  feature: VectorFeature,
  sourceFeatureIndex: number,
): SelectedFeatureRef {
  const id = featureId(feature);
  return {
    layerId,
    sourceId,
    sourceFeatureIndex,
    featureId: id,
    key: JSON.stringify([layerId, sourceId, sourceFeatureIndex, id]),
  };
}
